'use client';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

interface BackdropProps {
  onClick?: () => void;
}

const Backdrop = ({ onClick }: BackdropProps) => {
  const [portalRoot, setPortalRoot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const root = document.getElementById('portal-root');
    if (root) {
      setPortalRoot(root);
    }
  }, []);

  if (!portalRoot) {
    return null;
  }

  return ReactDOM.createPortal(
    <button
      type="button"
      className="fixed inset-0 z-48 bg-black/60 lg:bg-transparent lg:cursor-default"
      onClick={onClick}
    />,
    portalRoot,
  );
};

export default Backdrop;
